import { AutogenModelMasterOrder, AutogenRowMasterOrder } from "./autogen/AutogenModelMasterOrder";

export class ModelMasterOrder extends AutogenModelMasterOrder<RowMasterOrder> {
	constructor() {
		super(RowMasterOrder);
	}
}

export class RowMasterOrder extends AutogenRowMasterOrder {
}